import React, { useEffect, useState } from "react";
import { useApi } from "../apiClient";

export default function AdminDashboardModal({ show, onClose }) {
  const api = useApi();
  const [feedbacks, setFeedbacks] = useState([]);

  useEffect(() => {
    if (!show) return;
    api.admin.getFeedback()
      .then(data => setFeedbacks(data || []))
      .catch(() => setFeedbacks([]));
  }, [show]); // eslint-disable-line react-hooks/exhaustive-deps

  if (!show) return null;

  return (
    <div className="fixed inset-0 bg-black/40 z-50 flex items-center justify-center">
      <div className="bg-white rounded-xl p-6 w-full max-w-lg shadow-lg">
        <div className="flex justify-between items-center mb-3">
          <h3 className="text-lg font-bold">All Feedback</h3>
          <button onClick={onClose} className="text-gray-500 hover:text-black font-bold">✕</button>
        </div>
        <div className="overflow-auto max-h-[60vh]">
          {feedbacks.length === 0 && <div className="text-gray-500 text-center py-8">No feedback yet.</div>}
          {feedbacks.map((fb, idx) => (
            <div key={fb.id || idx} className="mb-4 p-3 border rounded-lg bg-gray-50">
              <div className="flex items-center gap-2 mb-1">
                <span className="text-yellow-500 text-lg">{"★".repeat(fb.rating)}{"☆".repeat(5 - fb.rating)}</span>
                <span className="text-xs text-gray-400 ml-auto">{fb.created_at && new Date(fb.created_at).toLocaleString()}</span>
              </div>
              <div className="text-gray-800">{fb.comment || <span className="text-gray-400 italic">No comment</span>}</div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}